export enum THREE_DEPARTMENT_STORAGE_KEYS {
  DateFromPreference = "three-department-date-from-preference",
  DateToPreference = "three-department-date-to-preference",
  NotCheckedByPreference = "three-department-not-checked-by-preference",
  PageSizePreference = "three-department-page-size-preference"
}
